import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate } from 'react-router-dom';

const ViewTOurs = () => {
  const [tours, setTours] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [tourToDelete, setTourToDelete] = useState(null);

  // Initialize useNavigate hook
  const navigate = useNavigate();

  // Fetch data from API using axios
  useEffect(() => {
    axios.get('https://genzserver.mylksystems.com/Tours/getTourHeader')
      .then((response) => {
        setTours(response.data.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the tours data!", error);
      });
  }, []);

  // Filter tours based on search query
  const filteredTours = tours.filter((tour) =>
    (tour.Title || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handle image click to open modal
  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  // Handle modal close
  const handleClose = () => {
    setOpen(false);
    setSelectedImage('');
  };

  // Handle row click to navigate to UpdateTour
  const handleUpdateClick = (tourId) => {
    navigate('/UpdateTours', { state: { TourId: tourId } });
  };

  // Open the delete confirmation dialog
  const handleDeleteClick = (tourId) => {
    setTourToDelete(tourId);
    setConfirmDelete(true);
  };

  // Close the delete confirmation dialog
  const handleCloseDelete = () => {
    setConfirmDelete(false);
    setTourToDelete(null);
  };

  // Handle deleting the tour
  const handleConfirmDelete = () => {
    if (tourToDelete) {
      // Make an API call to delete the tour
      axios.post(`https://genzserver.mylksystems.com/Tours/deleteTour`, { tourId: tourToDelete })
        .then((response) => {
          console.log(response.data);
          setTours(tours.filter((tour) => tour.TourId !== tourToDelete));
          handleCloseDelete();
        })
        .catch((error) => {
          console.error("Error deleting tour:", error);
          alert('Failed to delete the tour. Please try again.');
        });
    }
  };

  return (
    <div className="page-shell">
      <div className="table-toolbar">
        <div>
          <span className="eyebrow"><MapIcon fontSize="small" /> Tour library</span>
          <h1>Manage tours</h1>
          <p>Search, preview, update, or remove published tour packages.</p>
        </div>

        <TextField
          label="Search tours"
          variant="outlined"
          className="table-search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <TableContainer component={Paper} className="admin-table-card">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tour ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Cover Image</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTours.map((tour) => (
              <TableRow key={tour.TourId}>
                <TableCell>{tour.TourId}</TableCell>
                <TableCell>{tour.Title}</TableCell>
                <TableCell>{tour.description?.length > 50 ? `${tour.description.substring(0, 50)} ...` : tour.description}</TableCell>
                <TableCell>{tour.days} days</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleClickOpen(`https://genzserver.mylksystems.com/Assets/Tours/${tour.Photo}`)} aria-label="View tour image">
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => handleUpdateClick(tour.TourId)}
                    sx={{ mr: 1, mb: { xs: 1, sm: 0 } }}
                  >
                    Update
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDeleteClick(tour.TourId)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {filteredTours.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="empty-state">
                  No tours match your search.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Tour Image</DialogTitle>
        <DialogContent>
          <img src={selectedImage} alt="Tour" style={{ width: '100%', height: 'auto', borderRadius: 8 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this tour?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ViewTOurs;
